import React, { Component } from 'react'
import { connect } from 'react-redux'
import ClientManager from '../../components/clients/ClientManager'

class Client extends Component {
  render() {
    return (
      <div>
        <ClientManager />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {

    }
}
const mapDispatchToProps = {
}
export default connect(mapStateToProps, mapDispatchToProps)(Client)